export const BADGE_VARIANT = {
  NEUTRAL: 'neutral',
  GROWTH: 'growth',
  DECLINE: 'decline',
  EMPTY: 'empty',
}

export const NOT_AVAILABLE = 'N/A'
